import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import temprorary1 from '../../Imgs/collection-modern-tech-gadgets-including-smartphones-earbuds-smartwatch-headphones-tablet-charger-array-various-400391239.webp'
import api from "../../api";
import { useNavigate } from "react-router-dom";


export default function TopSearchedProducts({ products, onSelectProduct }) {
  const [detailedProducts, setDetailedProducts] = useState([]);
  const img = temprorary1 ;


  const navigate = useNavigate();

const handleSelect = (p) => {
  onSelectProduct(p);                      // keep your existing function
  navigate(`/products/${p.hyveProductId}`); // push route
};


  // Fetch details for each product when products change
  useEffect(() => {
    if (!products.length) return;

    const fetchAllDetails = async () => {
      try {
        const results = await Promise.all(
          products.slice(0,3).map((p) =>
            api
              .get(
                `/master-catalogue/api/catalogue/product/${p.hyveProductId}`,
                { headers: { Accept: "application/json" } }
              )
              .then((r) => r.data)
              .catch(() => null)
          )
        );

        // Filter out failed API calls
        setDetailedProducts(results.filter(Boolean));
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchAllDetails();
  }, [products]);

  if (!detailedProducts.length) return null;

  return (
    <section className="bg-white/95 border border-slate-200/80 rounded-2xl shadow-xl p-5 space-y-3">
      <header className="flex items-center justify-between gap-3">
        <h3 className="text-sm font-semibold">Top searched products</h3>
        <span className="px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 text-[0.7rem]">
          Dubai shoppers now
        </span>
      </header>

      <div className="grid gap-2.5 sm:grid-cols-2 md:grid-cols-3">
        {detailedProducts.slice(0,3).map((p) => (
          <button
            key={p.hyveProductId}
            type="button"
            onClick={() => handleSelect(p)}
            className="flex items-center gap-2 text-left border border-slate-200/80 rounded-2xl p-1.5 bg-white hover:border-indigo-500 hover:shadow-lg transition"
          >
            <div className="overflow-hidden">
            <img
              src={p.media[0]?.url || img || ""}
              alt={p.productName}
              className="w-16 h-16 rounded-xl object-cover"
            />
            </div>

            <div className="flex-1 min-w-0 flex flex-col gap-0.5">
              <p className="text-[0.8rem] font-semibold line-clamp-2">{p.productName}</p>
              <p className="text-[0.72rem] text-slate-500">{p.categoryPath}</p>

              <p className="text-[0.72rem] text-indigo-700 inline-flex items-center gap-1">
                View in-store offers <ArrowRight className="w-3 h-3" />
              </p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
